import { apiEndPoint } from 'config';
import { apiConstants } from '../constants';
import { authHeader, handleResponse } from 'helpers';
import { queryFilters, queryWhere } from '../helpers/util';

export const filedownloadService = {
  getAll,
  add,
  downloadFile
};

function getAll(limit, page, filters = undefined) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getFilesDownload;
  var queryfilters = queryFilters(limit, page);
  if (filters) queryfilters = queryfilters.concat('', queryWhere(filters));
  return fetch(`${url}${queryfilters}`, requestOptions)
    .then(handleResponse);
}


function add(category, report_name, limit, page, filters = undefined) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.addFileDownload.replace(':category', category);
  url = url.replace(':report_name', report_name);
  var queryfilters = queryFilters(limit, page);
  if (filters) queryfilters = queryfilters.concat('', queryWhere(filters));
  return fetch(`${url}${queryfilters}`, requestOptions)
    .then(handleResponse);
}

function downloadFile(filename) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  var url = apiConstants.getFileDownload.replace(':report_name', filename);
  return fetch(url, requestOptions)
    .then(response => {
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
      });
    });
}
